import { styled, TableCell, tableCellClasses, TablePagination, tablePaginationClasses, TableRow } from '@mui/material'
import { fontFamilyMonserrat, gecinaBlueMain } from '../../../theme'

const TABLE_TEXT_STYLE = {
	color: gecinaBlueMain,
	fontFamily: fontFamilyMonserrat,
	lineHeight: '18px'
}

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.root}`]: {
		borderColor: theme.palette.blue['10']
	},
	[`&.${tableCellClasses.head}`]: {
		...TABLE_TEXT_STYLE,
		fontSize: 14,
		fontWeight: 600
	},
	[`&.${tableCellClasses.body}`]: {
		...TABLE_TEXT_STYLE,
		fontSize: 14,
		fontWeight: 400
	}
}))

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.blue['5']
	}
}))

const PAGINATION_TEXT_STYLE = {
	...TABLE_TEXT_STYLE,
	fontSize: 12,
	fontWeight: 400
}

export const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
	[`.${tablePaginationClasses.selectLabel}`]: PAGINATION_TEXT_STYLE,
	[`.${tablePaginationClasses.select}`]: PAGINATION_TEXT_STYLE,
	[`.${tablePaginationClasses.menuItem}`]: PAGINATION_TEXT_STYLE,
	[`.${tablePaginationClasses.displayedRows}`]: PAGINATION_TEXT_STYLE
}))